import React, { useMemo } from "react";

const COLORS = ["#FF3B30", "#007AFF", "#FFCC00", "#34C759", "#AF52DE", "#FF9500", "#32ADE6"];

export const Confetti = ({ pieces = 80 }) => {
  const items = useMemo(() => {
    return Array.from({ length: pieces }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.6,
      duration: 2.5 + Math.random() * 2.5,
      color: COLORS[i % COLORS.length],
      rotate: Math.random() * 360,
    }));
  }, [pieces]);

  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-50" aria-hidden="true">
      {items.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            backgroundColor: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
